import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL } from './api';
import DEV_BRANDS from './brands.dev';

const BrandsContext = createContext([]);

export function BrandsProvider({ children }) {
  const [brands, setBrands] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${BASE_URL}/api/brands`)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load brands (HTTP ${res.status})`);
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) throw new Error('Invalid brands payload');
        setBrands(data);
      })
      .catch(() => {
        if (process.env.NODE_ENV === 'development') {
          console.warn('BrandsContext: API unreachable, using local dev fallback.');
          setBrands(DEV_BRANDS);
        } else {
          setError(true);
        }
      });
  }, []);

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <p>Could not load brand configuration. Please check your connection and refresh.</p>
      </div>
    );
  }

  if (!brands) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <BrandsContext.Provider value={brands}>
      {children}
    </BrandsContext.Provider>
  );
}

export function useBrands() {
  return useContext(BrandsContext);
}

export function useGetBrand() {
  const brands = useBrands();
  return (name) => brands.find((b) => b.name === name);
}
